import React, { Component } from 'react';

class Resume extends Component {
  renderBullets(items) {
    if (!Array.isArray(items)) {
      return null;
    }

    return items.map(function(item) {
      return <li key={item}>{item}</li>;
    });
  }

  renderWork(items) {
    if (!Array.isArray(items)) {
      return null;
    }

    return items.map(function(work) {
      return (
        <article className="timeline-item" key={work.company + work.title + work.years}>
          <div className="timeline-meta">
            <span>{work.years}</span>
            <span>{work.location}</span>
          </div>
          <div className="timeline-content">
            <h3>{work.title || work.company}</h3>
            <p className="company">{work.company}</p>
            {work.narrative && <p className="role-narrative">{work.narrative}</p>}
            {this.renderRoles(work.roles)}
            <ul>
              {this.renderBullets(work.highlights)}
            </ul>
          </div>
        </article>
      );
    }.bind(this));
  }

  renderRoles(roles) {
    if (!Array.isArray(roles)) {
      return null;
    }

    return (
      <div className="role-progression">
        {roles.map(function(role) {
          return (
            <div className="role-step" key={role.title + role.years}>
              <span>{role.years}</span>
              <strong>{role.title}</strong>
            </div>
          );
        })}
      </div>
    );
  }

  renderSkillGroups(groups) {
    if (!Array.isArray(groups)) {
      return null;
    }

    return groups.map(function(group) {
      return (
        <article className="skill-card" key={group.title}>
          <h3>{group.title}</h3>
          <div className="tag-list">
            {group.items.map(function(item) {
              return <span key={item}>{item}</span>;
            })}
          </div>
        </article>
      );
    });
  }

  renderEducation(items) {
    if (!Array.isArray(items)) {
      return null;
    }

    return items.map(function(item) {
      return (
        <article className="credential-card" key={item.school + item.degree}>
          <h3>{item.school}</h3>
          <p>{item.degree}</p>
          <span>{item.graduated}</span>
        </article>
      );
    });
  }

  renderCertifications(items) {
    if (!Array.isArray(items)) {
      return null;
    }

    return items.map(function(item) {
      return <li key={item}>{item}</li>;
    });
  }

  render() {
    var data = this.props.data || {};

    return (
      <section id="resume" className="section resume-section">
        <div className="section-heading">
          <p className="eyebrow">Experience</p>
          <h2>Enterprise delivery across data platforms, BI, cloud migration, and AI-ready architecture.</h2>
        </div>

        <div className="timeline">
          {this.renderWork(data.work)}
        </div>

        <div className="section-heading compact">
          <p className="eyebrow">Capabilities</p>
          <h2>Where architecture, engineering, and analytics meet.</h2>
        </div>

        <div className="skill-grid">
          {this.renderSkillGroups(data.skillGroups)}
        </div>

        <div className="credential-grid">
          <div>
            <p className="eyebrow">Education</p>
            <div className="credential-list">
              {this.renderEducation(data.education)}
            </div>
          </div>
          <div>
            <p className="eyebrow">Certifications</p>
            <ul className="certification-list">
              {this.renderCertifications(data.certifications)}
            </ul>
          </div>
        </div>
      </section>
    );
  }
}

export default Resume;
